module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Детали клиента\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('a', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        return _vm.smartBackButton('all-clients')
      }
    }
  }, [_vm._v("← Назад к Клиентам")])]), _vm._v(" "), _c('clientDetail', {
    attrs: {
      "client-id": _vm.$route.params.client_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-185ec945","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/ClientDetails.vue
// module id = 588
// module chunks = 0